module.exports = __webpack_public_path__ + "img/20210701_172447.0ce1f8b0.jpg";